export const LOADING_STRATEGIC_PILLAR = "LOADING_STRATEGIC_PILLAR";
export const SAVE_LOADING_STRATEGIC_PILLAR = "SAVE_LOADING_STRATEGIC_PILLAR";
export const GET_STRATEGIC_PILLAR = "GET_STRATEGIC_PILLAR";
export const FORM_FAIL = "FORM_FAIL";
export const STRATEGIC_PILLAR_FAIL = "STRATEGIC_PILLAR_FAIL";
export const LOADING_STRATEGIC_PILLAR_BY_ID = "LOADING_STRATEGIC_PILLAR_BY_ID";
export const GET_STRATEGIC_PILLAR_BY_ID = "GET_STRATEGIC_PILLAR_BY_ID";

